import "./SubContractors.css";
import { TableRowLoader } from "../../components/index";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";

function SiteDetailsTable(siteTimesheetDetails) {
  const navigate = useNavigate();

  return (
    <Table className="common-table sub-contractor_table" bordered>
      <thead>
        <tr>
          <th>PAYMENT DATE</th>
          <th></th>
          <th>TIMESHEET PERIOD</th>
          <th></th>
          <th>NO. OF CONTRACTORS</th>
          <th></th>
          <th>SITE SPECIFIC TRAINING MATRIX</th>
        </tr>
      </thead>
      <tbody>
        {!siteTimesheetDetails?.siteTimesheetDetails?.TimeSheets.length ? <td colSpan={7} style={{ fontSize: '1rem', textAlign:'center' }}>No Data Found</td> : siteTimesheetDetails?.siteTimesheetDetails?.TimeSheets.map(
          (item, index) => {

            return (
              <tr
                key={index}
                onClick={() =>
                  navigate(`/sites/site-traingMatrix?site_id=${item.site_id}`, {
                    state: {
                      siteInfo: {
                        working_period_start: item?.working_period_start,
                        working_period_end: item.working_period_end,
                      },
                    },
                  })
                }
              >
                <td>
                  {item?.last_date_of_pay_roll
                    ? item?.last_date_of_pay_roll
                    : ""}
                </td>
                <td></td>
                <td>
                  {item?.working_period_start
                    ? item?.working_period_start
                    : ""}
                  -
                  {item?.working_period_end ? item?.working_period_end : ""}
                </td>
                <td></td>
                <td>
                  {item?.no_of_sole_traders ? item?.no_of_sole_traders : ""}
                </td>
                <td></td>
                <td>
                  <button>View Details</button>
                </td>
              </tr>
            );
          }
        )}
      </tbody>
    </Table>
  );
}

export default SiteDetailsTable;
